import { render, staticRenderFns } from "./SetupCostSuccess.vue?vue&type=template&id=4842e143&scoped=true&"
import script from "./SetupCostSuccess.vue?vue&type=script&lang=js&"
export * from "./SetupCostSuccess.vue?vue&type=script&lang=js&"
import style0 from "./SetupCostSuccess.vue?vue&type=style&index=0&id=4842e143&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4842e143",
  null
  
)

export default component.exports